import type { ComponentProps } from 'react';
import { OwcToggleButtonGroup } from '@one/react';

export type PocToggleButtonGroupProps = ComponentProps<typeof OwcToggleButtonGroup>;

export const PocToggleButtonGroup: React.FC<PocToggleButtonGroupProps> = (props) => <OwcToggleButtonGroup {...props} />;
